import { Component } from '@angular/core';
import { BaseService } from '../shared-service/base.service';

@Component({
  selector: 'page-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})

export class PageNotFoundComponent {
  title = 'app';
  constructor(public bs:BaseService) {
    this.bs.log('error',"Loaded PageNotFoundComponent");
  };
}
